import { type TopLevelDataObj } from "@hsl/fund-explorer/types";

import { type Config, type TabConfig } from "../../config/types";
import GroupedTabView from "./views/GroupedTabView";
import TabView from "./views/TabView";

export interface Props {
    shareClasses: string[];
    config: Config;
    tab: TabConfig;
    groupShareClasses?: boolean;
    subTabs?: (TabConfig & { date?: string })[];
    spacedTabs?: boolean;
    footnote?: string;
    groups?: Record<string, TopLevelDataObj[]>;
}

const TableView = (props: Props) => {
    if (props.groupShareClasses) {
        return <GroupedTabView {...props} />;
    } else {
        return <TabView {...props} />;
    }
};

export default TableView;
